const METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
}
module.exports.METHODS = METHODS;

/**
 * Http GET request to eProc-api
 * @param url {string}
 * @return {Promise<any>}
 */
function get(url) {
    return apiCall(url, METHODS.GET);
}
module.exports.get = get;

/**
 * Http POST request to eProc-api
 * @param url {string}
 * @param data {any}
 * @return {Promise<any>}
 */
function post(url, data = {}) {
    return apiCall(url, METHODS.POST, data);
}
module.exports.post = post;

/**
 * Http PUT request to eProc-api
 * @param url {string}
 * @param data {any}
 * @return {Promise<any>}
 */
function put(url, data = {}) {
    return apiCall(url, METHODS.PUT, data);
}
module.exports.put = put;

/**
 * Http DELETE request to eProc-api
 * @param url {string}
 * @param data {any}
 * @return {Promise<any>}
 */
function deleteRequest(url, data = {}) {
    return apiCall(url, METHODS.DELETE, data);
}
module.exports.deleteRequest = deleteRequest;

/**
 * Http util for calling eProc API via jquery AJAX
 * @param url {string}
 * @param method - 'GET', 'POST', 'PUT' or 'DELETE'
 * @param data {any}
 * @return {Promise<unknown>}
 */
function apiCall(url, method, data = {}) {
    return new Promise((resolve, reject) => {
        const options = {
            url,
            headers: {'Authorization': 'Bearer ' + sessionStorage.getItem(window.STORAGE_KEY.TOKEN)},
            type: method,
            success: function (data) {
                resolve(data);
            },
            error: (error) => {
                reject(error);
            }
        };
        if(data) {
            options.contentType = 'application/json';
            options.data = data;
        }

        $.ajax(options);
    })
}
